// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "video-module--base-text-alt--global--b1159";
export var baseTextGlobal = "video-module--base-text--global--8fd0f";
export var blockSpacing100 = "video-module--block-spacing-100--3367e";
export var blockSpacing50 = "video-module--block-spacing-50--72dcf";
export var blockVPadding100 = "video-module--block-v-padding-100--08edb";
export var blockVPadding50 = "video-module--block-v-padding-50--03106";
export var caption = "video-module--caption--e8882";
export var captionTextGlobal = "video-module--caption-text--global--76286";
export var cmsRenderedContentGlobal = "video-module--cms-rendered-content--global--4f909";
export var container = "video-module--container--6a2bb";
export var contentContainer = "video-module--contentContainer--419d4";
export var defaultHSpacingGlobal = "video-module--default-h-spacing--global--667c4";
export var fadeInAnimation = "video-module--fadeInAnimation--eabef";
export var fadeInOnLoadGlobal = "video-module--fade-in-on-load--global--fabbe";
export var fullHeightGlobal = "video-module--full-height--global--a0ecc";
export var fullHeightOmittingNavGlobal = "video-module--full-height-omitting-nav--global--c0935";
export var headingTextGlobal = "video-module--heading-text--global--59d47";
export var ingressTextGlobal = "video-module--ingress-text--global--9fac2";
export var linkColorChangeTransitionGlobal = "video-module--link-color-change-transition--global--99c18";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "video-module--page-heading-text--global--2f9c6";
export var paragraphTextGlobal = "video-module--paragraph-text--global--f43d0";
export var subheadingTextGlobal = "video-module--subheading-text--global--b30a3";
export var title = "video-module--title--8e39b";
export var videoContainer = "video-module--videoContainer--e0de1";